module.exports = __webpack_public_path__ + "img/halino@2x.4c24c26.png";